/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Bridge, BridgeInterface } from "../Bridge";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tonAddress",
        type: "uint256",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "EIP712DomainChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "Receive",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "GGR",
    outputs: [
      {
        internalType: "contract IERC20Upgradeable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OWNER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VOUCHER_SIGNER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "__GgrEscrow_init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tonAddress",
        type: "uint256",
      },
    ],
    name: "depositGgr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20Upgradeable",
        name: "token",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "users",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "distribute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "eip712Domain",
    outputs: [
      {
        internalType: "bytes1",
        name: "fields",
        type: "bytes1",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "version",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "chainId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "verifyingContract",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "salt",
        type: "bytes32",
      },
      {
        internalType: "uint256[]",
        name: "extensions",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getChainID",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "expireTime",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct ReceiveGgrVoucher.ReceiveVoucher",
        name: "voucher",
        type: "tuple",
      },
    ],
    name: "receiveGgr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20Upgradeable",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type BridgeConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BridgeConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Bridge__factory extends ContractFactory {
  constructor(...args: BridgeConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(overrides?: Overrides & { from?: string }): Promise<Bridge> {
    return super.deploy(overrides || {}) as Promise<Bridge>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): Bridge {
    return super.attach(address) as Bridge;
  }
  override connect(signer: Signer): Bridge__factory {
    return super.connect(signer) as Bridge__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BridgeInterface {
    return new utils.Interface(_abi) as BridgeInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Bridge {
    return new Contract(address, _abi, signerOrProvider) as Bridge;
  }
}
